"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.styles = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _DefaultTextField = _interopRequireDefault(require("./DefaultTextField"));

var _DefaultSuggestion = _interopRequireDefault(require("./DefaultSuggestion"));

var _DefaultSuggestionsContainer = _interopRequireDefault(require("./DefaultSuggestionsContainer"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _defineStyles = require("@sift/skipper/styles/defineStyles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = (0, _defineStyles.defineStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      position: 'relative'
    },
    suggestionsPaper: {
      position: 'absolute',
      width: '100%',
      minWidth: 200,
      zIndex: theme.zIndex.max
    },
    suggestionsContainer: {
      width: '100%'
    },
    suggestionsContainerOpen: {},
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none'
    },
    suggestion: {
      display: 'block'
    }
  };
}); // @ts-ignore

exports.styles = styles;
/**
 * Skippers Autosuggest is derived from react-autosuggest. This is
 * a convenience wrapper that gives us some simple defaults.
 *
 * For more details on input / component overrides...
 * Look here https://github.com/moroshko/react-autosuggest#inputPropsProp
 */

var Autosuggest = /*#__PURE__*/function (_React$Component) {
  _inherits(Autosuggest, _React$Component);

  var _super = _createSuper(Autosuggest);

  function Autosuggest() {
    var _this;

    _classCallCheck(this, Autosuggest);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsClearRequested", function () {
      // @ts-ignore
      if (_this.props.onSuggestionsClearRequested) {
        // @ts-ignore
        _this.props.onSuggestionsClearRequested();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSuggestionValue", function (suggestion) {
      return suggestion;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuggestionsContainer", function (containerProps) {
      return (0, _DefaultSuggestionsContainer["default"])(containerProps, {
        classes: {
          root: _this.props.classes.suggestionsPaper
        }
      });
    });

    return _this;
  }

  _createClass(Autosuggest, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          theme = _this$props.theme,
          other = _objectWithoutProperties(_this$props, ["classes", "className", "theme"]);

      return /*#__PURE__*/_react["default"].createElement(_reactAutosuggest["default"] // @ts-ignore
      , _extends({
        getSuggestionValue: this.getSuggestionValue,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        renderSuggestionsContainer: this.renderSuggestionsContainer,
        theme: _objectSpread({
          container: (0, _classnames["default"])(classes.root, className),
          suggestionsContainer: classes.suggestionsContainer,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        }, theme)
      }, other));
    }
  }]);

  return Autosuggest;
}(_react["default"].Component);

_defineProperty(Autosuggest, "defaultProps", {
  inputProps: {
    value: '',
    onChange: function onChange() {},
    placeholder: 'Enter a value'
  },
  suggestions: [],
  renderInputComponent: _DefaultTextField["default"],
  renderSuggestion: _DefaultSuggestion["default"]
});

var _default = (0, _withStyles["default"])(styles)(Autosuggest);

exports["default"] = _default;